<!DOCTYPE html>
<head>
<meta name="viewport" content="width=device-width, initial-scale=1">
</head>
<ng-container *ngIf="user">
  <app-toolbar [user]="user" [back]="true" [destination]="destination"></app-toolbar>
</ng-container>

<div class="column">
  <h2>Pazienti globali - Utenti che non hanno effettuato l'accesso</h2>
    <h3>L'analisi è stata effettuata considerando i pazienti che hanno compilato il questionario HBI.</h3>

  <mat-spinner [diameter]="50" *ngIf="!isDataAvailable" style="left: 30%"></mat-spinner>

  <div style="display: inline-block" style = "padding-left: 3vw; padding-top: 0vw; position: center">
    <div class = "chart-container" [ngStyle]="{'cursor': isHovered ? 'pointer' : ''}">
      <canvas id = "myChartNeverLogged"></canvas>
    </div>
    <div class = "chart-container" [ngStyle]="{'cursor': isHovered ? 'pointer' : ''}">
    </div>
  </div>
</div>

<div class="column">
  <ng-container *ngIf="isTableLoginAvailable">
    <div class="mat-elevation-z8">
    <div id="myModal2" class="modal">
      <!-- Modal content -->
      <div class="modal-content" style="background-color: #FFFFFF">
        <div class ="modal-header" style="background-color: #008d8d">
          <span class="close" style="padding: 10px;" (click)="hideTableLogin()">&times;</span>
          <h4 class="modal-title" style = "color: white; font-weight: bold; padding-left: 50px"> Pazienti che non hanno mai effettuato l'accesso</h4>
        </div>
        <div class="modal-body">
          <table mat-table [dataSource]="dataSource">
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef> <mat-checkbox (change)= "selectAllNeverLogged($event)"> Seleziona tutti  </mat-checkbox> </th>
              <td mat-cell *matCellDef="let element">
                <mat-checkbox *ngIf="selectedNeverLogged; else elseBlock" [(ngModel)]="element.checked" (change)="changeNeverLoggedItem($event, element)"> </mat-checkbox>
                <ng-template #elseBlock> <mat-checkbox (change)="selectNeverLoggedItems($event, element)"></mat-checkbox> </ng-template> </td>
            </ng-container>
            <!-- Position Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef> Nome </th>
              <td mat-cell *matCellDef="let element"> {{element.name}} </td>
            </ng-container>
            <!-- Name Column -->
            <ng-container matColumnDef="surname">
              <th mat-header-cell *matHeaderCellDef> Cognome </th>
              <td mat-cell *matCellDef="let element"> {{element.surname}} </td>
            </ng-container>
            <!-- Button column -->
            <ng-container matColumnDef="sollecita" colspan="0">
              <td mat-footer-cell *matFooterCellDef>
                <button mat-button mat-raised-button color="primary" style="position: center" (click)="sendMailNeverLogged()"> Sollecita </button>
              </td>
            </ng-container>
            <!-- Paginator column -->
            <ng-container matColumnDef="paginator">
              <td mat-footer-cell *matFooterCellDef colspan="4">
                <mat-paginator [pageSizeOptions]="[5, 10, 20]"
                               [length]="totalSize"
                               [pageSize]="5"
                               (page)="handlePage($event)">showFirstLastButtons></mat-paginator>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="headElementsNeverLogged"></tr>
            <tr mat-row *matRowDef="let row; columns: headElementsNeverLogged;"></tr>
            <tr mat-footer-row *matFooterRowDef="['sollecita', 'paginator']"></tr>
          </table>
        </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
